var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-soloarsymulator":""}},[_c('div',{class:[_vm.size ? _vm.size : ''],attrs:{"id":"photovoltaics"}},[_c('Symulator')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }